import { useState, useEffect } from 'react';

const OfflineBanner = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    const handleOffline = () => {
      setIsOnline(false);
      setShowReconnected(false);
    };

    const handleOnline = () => {
      setIsOnline(true);
      setShowReconnected(true);
      const t = setTimeout(() => setShowReconnected(false), 3000);
      return () => clearTimeout(t);
    };

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  if (isOnline && !showReconnected) return null;

  if (!isOnline) {
    return (
      <div
        role="alert"
        className="fixed top-0 left-0 right-0 z-[9999] flex items-center justify-center gap-3 px-4 py-3 text-sm font-semibold text-white"
        style={{ background: 'linear-gradient(135deg, #8B1A1A, #C44E0E)' }}
      >
        <span className="text-base">📡</span>
        <span>इंटरनेट कनेक्शन नहीं है — कृपया अपना नेटवर्क जांचें</span>
      </div>
    );
  }

  return (
    <div
      role="status"
      className="fixed top-0 left-0 right-0 z-[9999] flex items-center justify-center gap-3 px-4 py-3 text-sm font-semibold text-white"
      style={{ background: '#1E5B47' }}
    >
      <span className="text-base">✅</span>
      <span>इंटरनेट कनेक्शन वापस आ गया</span>
    </div>
  );
};

export default OfflineBanner;
